import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../../../../../src/helpers/reselectHelpers';
import {navigateToLinkAction} from '../../../../../../../../src/store/stateless/navigationActions';
import {ImportCSVHelpBanner} from './importCSVHelpBanner';

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  navigateToLink: navigateToLinkAction,
}));

export const ImportCSVHelpBannerContainer = connect(null, mapDispatchToProps)(ImportCSVHelpBanner);
